import find from 'lodash-es/find';
import Cookies from 'js-cookie';

export default (form) => {
  let variant_id = form.querySelector('[name="id"]').value;
  let productSectionElement = form.closest('[data-section-type="product"]') || form;
  let productJsonElement =
    productSectionElement.parentElement.querySelector('[data-product-json]') ||
    form.querySelector('[data-product-json]');
  let tile_type = productJsonElement.dataset.tileType;
  let variant = '';

  if (!variant_id || !productJsonElement) {
    return;
  }

  let product_json = JSON.parse(productJsonElement.innerHTML);
  if (tile_type && tile_type === 'certona') {
    variant_id = variant_id.toString();
    variant = find(product_json.variants, {
      variant_id,
    });
  } else {
    variant_id = Number(variant_id);
    variant = find(product_json.variants, {
      id: variant_id,
    });
  }

  let cart_items = Cookies.get('cart_items');
  cart_items = cart_items ? JSON.parse(cart_items) : {};

  cart_items[variant_id] = {
    compare_at_price: variant.compare_at_price,
    product_options: product_json.options,
    barcode: variant.barcode,
  };

  Cookies.set('cart_items', JSON.stringify(cart_items));
};
